export const workerStatusChoices = [
    { id: 'down', name: 'Down' },
    { id: 'free', name: 'Free' },
    { id: 'busy', name: 'Busy' },
    { id: 'hangup', name: 'Hangup' },
]

export const workerStatusChoicesUser = [
    { id: 'down', name: 'Down' },
    { id: 'hangup', name: 'Hangup' },
]

export const validateForm = () =>
    values => {
        const errors = {};
        if (!values.type) {
            errors.type = 'ra.validation.required';
        }
        if (!values.status) {
            errors.status = 'ra.validation.required';
        }
        return errors;
    };

const acceptKeys = ['type', 'status'];

export const transformRecord = (data) => {
    const sanitizedData = {};
    for (const key in data) {
        if (acceptKeys.includes(key) && data[key]) {
            sanitizedData[key] = data[key];
        }
    }
    return sanitizedData;
};
